import styled from "styled-components";



export default function ColTwo() {

  return (
    <div
      className="footer-link footer-col"
      data-aos="fade-up"
      data-aos-once="true"
    >

      <Text>
        Eridan Space Ikeja
      </Text>
      <a
        href="tel:+2348136854728"
        className="phone">
        (+234) 813-6854-728
      </a>
      <br />
      <address
        className="address">
        The Philippi Center, Oluwalogbon House,
        <br />
        Plot A Obafemi Awolowo Way,
        <br />
        Alausa Ikeja, Lagos.
      </address>
    </div>
  )
};


const Text = styled.div`
  font-family: Nunito;
  font-size: 24px;
  font-weight: 700;
  line-height: 28px;
  text-align: left;
  margin-bottom: 1rem;
  color: var(--white-color);
`;